import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNGroup } from './cngroup';

@RegisterItem()
export class CNDomain extends CNGroup {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNUser.CNUser.CNGroup.CNDomain';
    }

    public clone(): any {
        return new CNDomain();
    }
}
